// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"ee02874f","200":"99e52ab8","294":"27226657","385":"c708d9c7","472":"a7f0b259","475":"279e0a2f","483":"43d6149b","511":"54037a43","538":"917c7dc6","551":"6a744d21","641":"4d69c2fe","667":"61de0f9d","754":"6627b9f2","818":"d67f7818"}[chunkId] + ".js";
};